import {Shipment} from 'coreStore/data/orders/types';
import ShippingMethodModel from './ShippingMethodModel';
import AddressModel from './AddressModel';

/**
 * Represents an order shipment
 */
class ShipmentModel {
	private shipment: Shipment;
	private readonly shippingMethod: ShippingMethodModel;
	private readonly shippingAddress: AddressModel;

	/**
	 * @constructor
	 * @param {Shipment} shipment - shipment
	 */
	constructor(shipment) {
		this.shipment = Object.assign({}, shipment);
		this.shippingMethod = new ShippingMethodModel(this.shipment.shippingMethod);
		this.shippingAddress = new AddressModel(this.shipment.shippingAddress);
	}

	/**
	 * Returns shipping method
	 * @returns {ShippingMethodModel} shipping method
	 */
	getShippingMethod() {
		return this.shippingMethod;
	}

	/**
	 * Returns shipping address
	 * @returns {AddressModel} shipping address
	 */
	getShippingAddress() {
		return this.shippingAddress;
	}

	/**
	 * Returns shipping total price
	 * @returns {number} shipping total price
	 */
	getShipmentTotal() {
		return this.shipment.shipmentTotal;
	}

	/**
	 * Returns shipping cost
	 * @returns {number} shipping cost
	 */
	getShippingCost() {
		return this.shipment.shippingCost;
	}

	/**
	 * Returns shipping total
	 * @returns {number} shipping cost
	 */
	getShippingTotal() {
		return this.shipment.shippingTotal;
	}
}

export default ShipmentModel;
